const work = [
  {
    artwork: process.env.PUBLIC_URL + "assets/blackcurrents-blackcurrentsdemoep.png",
    artist: "Black Currents",
    title: "Black Currents Demos - EP",
    role: "Drums on Black Cat & Mastering",
    releaseDate: "2026-03-12",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1885173594",
      spotify: "https://open.spotify.com/album/4AeLahvIMqoi0u2TPpYrDG",
      amazonmusic: "https://music.amazon.com/albums/B0GSJXJXPB",
      soundcloud: "https://soundcloud.com/blackcurrents/sets/black-currents-demos",
      tidal: "https://listen.tidal.com/album/507120303",
      bandcamp: "https://blackcurrents.bandcamp.com/album/black-currents-demos",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/katewatts-growingpains.jpg",
    artist: "Kate Watts",
    title: "Growing Pains",
    role: "Mastering",
    releaseDate: "2025-12-16",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1853893962",
      spotify: "https://open.spotify.com/track/7bjJQ7vSD2czKtbFjcB4AN",
      youtube: "",
      youtubemusic: "https://music.youtube.com/watch?v=I70klzp51-I",
      soundcloud: "",
      amazonmusic: "https://music.amazon.com/tracks/B0G291G9NH",
      tidal: "https://tidal.com/browse/track/473843000",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-occludeftkennyberthelot.jpeg",
    artist: "Mont Rose",
    title: "Occlude (ft. Kenny Berthelot)",
    role: "Mastering",
    releaseDate: "2025-08-25",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1818512490",
      spotify: "https://open.spotify.com/track/0cGRTB18GJ0pO9xA4G7mld",
      youtube: "https://www.youtube.com/watch?v=huktP-KeLSA",
      youtubemusic: "https://music.youtube.com/watch?v=huktP-KeLSA",
      soundcloud: "https://soundcloud.com/montrose-scmusic/occlude-feat-kenny-berthelot",
      amazonmusic: "https://music.amazon.com/albums/B0FBWTMMH8?trackAsin=B0FBVYWYV6",
      tidal: "https://listen.tidal.com/track/440029892",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-signsftdanieljfarthing.png",
    artist: "Mont Rose",
    title: "Signs (ft. Daniel J Farthing)",
    role: "Mastering",
    releaseDate: "2025-07-16",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1813327366",
      spotify: "https://open.spotify.com/track/5MR0BsyGnRv5L8TsfvqzEV",
      youtube: "https://www.youtube.com/watch?v=nr6u4BM12KI",
      youtubemusic: "https://music.youtube.com/watch?v=nr6u4BM12KI",
      soundcloud: "https://soundcloud.com/mont_rose/signs-ft-daniel-j-farthing",
      amazonmusic: "https://music.amazon.com/albums/B0F83FH9KR?trackAsin=B0F83HSWPW",
      tidal: "https://listen.tidal.com/track/434899541",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-meandyouftlheon.jpeg",
    artist: "Mont Rose",
    title: "Me and You (ft. Lhēon)",
    role: "Mastering",
    releaseDate: "2025-06-19",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1813327108",
      spotify: "https://open.spotify.com/track/2uhrfjYJnvkqklwoUxfAJY",
      youtube: "https://www.youtube.com/watch?v=9dZc6J_zRrI",
      youtubemusic: "https://music.youtube.com/watch?v=9dZc6J_zRrI",
      soundcloud: "https://soundcloud.com/mont_rose/me-and-you-ft-lheon",
      amazonmusic: "https://music.amazon.com/albums/B0F83F7L28?trackAsin=B0F83HHMWX",
      tidal: "https://listen.tidal.com/track/434899019",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/kennyberthelot-irunaway.jpg",
    artist: "Kenny Berthelot",
    title: "I Run Away",
    role: "Mastering",
    releaseDate: "2024-11-08",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1773470249",
      spotify: "https://open.spotify.com/track/6HD7goOYKCJhz1t60VC8Mu",
      youtube: "https://www.youtube.com/watch?v=AK-34W3NoOs",
      youtubemusic: "https://music.youtube.com/watch?v=AK-34W3NoOs",
      soundcloud: "https://soundcloud.com/kb92music/i-run-away-1",
      amazonmusic: "https://music.amazon.com/albums/B0DJVVZRD8?trackAsin=B0DJVVJZZN",
      tidal: "https://listen.tidal.com/track/392655971",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-shelterftjacintaleralph.jpg",
    artist: "Mont Rose",
    title: "Shelter (ft. Jacinta Le Ralph)",
    role: "Mastering",
    releaseDate: "2024-10-25",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1769553540",
      spotify: "https://open.spotify.com/track/2paKj4jvCTyC5nr7MVrGoT",
      youtube: "https://www.youtube.com/watch?v=w-lkvNE5o1Y",
      youtubemusic: "https://music.youtube.com/watch?v=w-lkvNE5o1Y",
      soundcloud: "https://soundcloud.com/mont_rose/shleter-mont-rose-ft-jacinta-le",
      amazonmusic: "https://music.amazon.com/albums/B0DHK75NYQ?trackAsin=B0DHK7CV5P",
      tidal: "https://listen.tidal.com/track/388526001",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-slideftdanieljfarthing.jpg",
    artist: "Mont Rose",
    title: "Slide (ft. Daniel J Farthing)",
    role: "Mastering",
    releaseDate: "2024-09-19",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1762586982",
      spotify: "https://open.spotify.com/track/4PVkfdTkZhXY1pvPzKYsL5",
      youtube: "https://www.youtube.com/watch?v=FUTXA60In0A",
      youtubemusic: "https://music.youtube.com/watch?v=FUTXA60In0A",
      soundcloud: "https://soundcloud.com/mont_rose/slideft-daniel-j-farthing-mont-rose",
      amazonmusic: "https://music.amazon.com/albums/B0DCZ1XRXB?trackAsin=B0DCYYY5V2",
      tidal: "https://listen.tidal.com/track/380950335",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/crybabycomet-saddestgirlintheworld.jpg",
    artist: "Crybaby Comet",
    title: "Saddest Girl In The World",
    role: "Mastering",
    releaseDate: "2024-07-10",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1755350930",
      spotify: "https://open.spotify.com/track/29YJGnMkSZ0H3YZDcAp9iM",
      youtube: "https://www.youtube.com/watch?v=KM1CtyTjGSw",
      youtubemusic: "https://music.youtube.com/watch?v=KM1CtyTjGSw",
      amazonmusic: "https://music.amazon.com/albums/B0D8LJ128W?trackAsin=B0D8LGY8H6",
      tidal: "https://listen.tidal.com/track/372715658",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/montrose-sameviewftrickberry.jpg",
    artist: "Mont Rose",
    title: "Same View (ft. Rick Berry)",
    role: "Mastering",
    releaseDate: "2024-04-10",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1770272653",
      spotify: "https://open.spotify.com/track/7N3xjvI6U3iNPGhjypdizp",
      youtube: "https://www.youtube.com/watch?v=z1aQ35VZPx0",
      youtubemusic: "https://music.youtube.com/watch?v=z1aQ35VZPx0",
      soundcloud: "https://soundcloud.com/montrose-scmusic/same-view-feat-rick-berry",
      amazonmusic: "https://music.amazon.com/albums/B0DHV6YKPV?trackAsin=B0DHV9L1GV",
      tidal: "https://listen.tidal.com/track/389192521",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/lunartide-pradasurf.jpg",
    artist: "Lunar Tide",
    title: "Prada Surf",
    role: "Mixing & Mastering",
    releaseDate: "2024-01-16",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1725945751",
      spotify: "https://open.spotify.com/track/3M4KmY7PGNlr7YyaIJcs0N",
      youtube: "https://www.youtube.com/watch?v=jqztsuXcgMc",
      youtubemusic: "https://music.youtube.com/watch?v=jqztsuXcgMc",
      soundcloud: "https://soundcloud.com/lunartideband/prada-surf",
      amazonmusic: "https://music.amazon.com/albums/B0CSFQBDWQ?trackAsin=B0CSFHGRBB",
      tidal: "https://listen.tidal.com/track/340167237",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/reveriebaby-reveriebaby.webp",
    artist: "Reverie Baby",
    title: "Reverie Baby",
    role: "Mastering",
    releaseDate: "2023-11-24",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/reverie-baby/1711949698",
      spotify: "https://open.spotify.com/album/1cqODNQ30ZFTwmshyItniw?si=UltuRE65Rx2pxKf4wcMvzQ",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_l1mNsrOzsbunlhaBP8DGFN5wS6RYhappY",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_l1mNsrOzsbunlhaBP8DGFN5wS6RYhappY",
      amazonmusic: "https://music.amazon.com/albums/B0CL2P9T9F",
      tidal: "https://tidal.com/browse/album/321815783",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-sadgirlsummer.jpeg",
    artist: "Reverie Baby/million",
    title: "sad girl summer",
    role: "Mastering",
    releaseDate: "2023-02-10",
    featured: false,
    show: true,
    links: {
      amazonmusic: "https://music.amazon.com/albums/B0BSDB5THF",
      applemusic: "https://geo.music.apple.com/au/song/sad-girl-summer-by-million/1665478549",
      tidal: "https://tidal.com/browse/track/271529092",
      youtubemusic: "https://music.youtube.com/watch?v=0-IR50BOCCA",
      youtube: "https://www.youtube.com/watch?v=0-IR50BOCCA",
      spotify: "https://open.spotify.com/track/784aY0jYltqaA3LVQmZSh1?si=47fd0ada815a46a7",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-bed+helooksbetteronme.png",
    artist: "Reverie Baby/million",
    title: "bed / he looks better on me",
    role: "Mixing & Mastering",
    releaseDate: "2022-09-16",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/0oHx6EJxJdKEBkuh2VYap8",
      applemusic: "https://geo.music.apple.com/au/album/bed-he-looks-better-on-me-by-million-single/1639655138",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kBuJ0bOOYTBReBgRhwQfjsBz6LLtsgiSc",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kBuJ0bOOYTBReBgRhwQfjsBz6LLtsgiSc",
      tidal: "https://tidal.com/browse/album/242961068",
      amazonmusic: "https://music.amazon.com/albums/B0B9JJ4R3Y",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-somethingright.jpg",
    artist: "Reverie Baby/million",
    title: "something right",
    role: "Mixing & Mastering",
    releaseDate: "2022-02-14",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/4APVWTfVCJOdTDFtiHwUlf",
      amazonmusic: "https://music.amazon.com/albums/B09QGP5R5W",
      tidal: "https://tidal.com/browse/album/212481335",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kod6EfpnyrTjEB8rOYEZ21K16mf3rsJpc",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kod6EfpnyrTjEB8rOYEZ21K16mf3rsJpc",
      applemusic: "https://geo.music.apple.com/au/album/something-right-by-million-single/1605331813",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-dejavu.png",
    artist: "Reverie Baby/million",
    title: "deja vu",
    role: "Mixing & Mastering",
    releaseDate: "2021-11-26",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/7KFfRfu2BJtnN6DOEaHDP0",
      applemusic: "https://geo.music.apple.com/au/album/deja-vu-by-million-single/1592585909",
      tidal: "https://tidal.com/browse/album/202883514",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_ltZZ8vefOExFRaFViKvhTItSam5jPtatM",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_ltZZ8vefOExFRaFViKvhTItSam5jPtatM",
      amazonmusic: "https://music.amazon.com/albums/B09KMKCJ6B",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-200days.jpg",
    artist: "Reverie Baby/million",
    title: "200 Days",
    role: "Mastering",
    releaseDate: "2021-09-15",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/5hGiq1W4VFKmhScVoEv68o",
      amazonmusic: "https://music.amazon.com/albums/B09G9HQS72",
      tidal: "https://tidal.com/browse/album/197707643",
      applemusic: "https://music.apple.com/au/album/200-days-by-million-single/1585932256",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_l6UStN2Lawv_h-OjH1J1o3vqkRq9UqGaE",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_l6UStN2Lawv_h-OjH1J1o3vqkRq9UqGaE",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/tashsultana-mtvunplugged.jpeg",
    artist: "Tash Sultana",
    title: "MTV Unplugged (Live in Melbourne)",
    role: "Engineering",
    releaseDate: "2022-05-13",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1608111267",
      spotify: "https://open.spotify.com/album/7d2SqyTg0hFU0r3H14CxL8",
      soundcloud: "https://soundcloud.com/tash-sultana/sets/mtv-unplugged-live-in-3",
      amazonmusic: "https://music.amazon.com/albums/B09RPHBMLG",
      tidal: "https://listen.tidal.com/album/229441885",
      bandcamp: "https://tashsultanaaus.bandcamp.com/album/mtv-unplugged-live-in-melbourne",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-messwemade.jpeg",
    artist: "Reverie Baby/million",
    title: "mess we made",
    role: "Mixing & Mastering",
    releaseDate: "2021-04-21",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/7KKy0xrFT2cGRjoMTjKToy",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_nxAbZQsFwAWts7lBqcFwRNyds170CHvTk",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_nxAbZQsFwAWts7lBqcFwRNyds170CHvTk",
      tidal: "https://tidal.com/browse/album/177953762",
      amazonmusic: "https://music.amazon.com/albums/B08ZLNL1LM",
      applemusic: "https://music.apple.com/au/album/mess-we-made-feat-million-single/1559411107",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/steviejean-menace.jpg",
    artist: "Stevie Jean",
    title: "Menace",
    role: "Engineering",
    releaseDate: "2021-05-14",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1568970041",
      spotify: "https://open.spotify.com/track/33rKmxsfYaDJs2lX1R3VJ1",
      youtube: "https://www.youtube.com/watch?v=HGmCaaLudxM",
      youtubemusic: "https://music.youtube.com/watch?v=HGmCaaLudxM",
      soundcloud: "https://soundcloud.com/steviejean-music/menace",
      amazonmusic: "https://music.amazon.com/albums/B08WQ2RZTG",
      tidal: "https://listen.tidal.com/track/173742767",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/themoonthemousethefrog.jpeg",
    artist: "Various Artists",
    title: "The Moon, The Mouse & The Frog: Lullabies from Northern Australia [ARIA Nominated]",
    role: "Mixing",
    releaseDate: "2021-02-19",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1583673215",
      spotify: "https://open.spotify.com/album/3WdMSlkau88f3nazxRrkhH",
      amazonmusic: "https://music.amazon.com/albums/B09F2R87N5",
      tidal: "https://listen.tidal.com/album/195971690",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/million-problem.jpg",
    artist: "Reverie Baby/million",
    title: "problem",
    role: "Mixing & Mastering",
    releaseDate: "2021-01-29",
    featured: false,
    show: true,
    links: {
      spotify: "https://open.spotify.com/album/1SBt7Fo0cRFNSQpe9Yix7n",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_lfOOdL34tYB1ooxlrfKc_IMllmCRwckq0",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_lfOOdL34tYB1ooxlrfKc_IMllmCRwckq0",
      tidal: "https://tidal.com/browse/album/168575582",
      amazonmusic: "https://music.amazon.com/albums/B08SFPLGRM",
      applemusic: "https://geo.music.apple.com/au/album/problem-single/1547849298",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/jxcky-lockdownlover.jpg",
    artist: "JXCKY",
    title: "Lockdown Lover",
    role: "Mastering",
    releaseDate: "",
    featured: false,
    show: false,
    links: {}
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/lunartide-takeme.jpg",
    artist: "Lunar Tide",
    title: "Take Me",
    role: "Engineering, Mixing & Mastering",
    releaseDate: "2020-06-12",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1515407505",
      spotify: "https://open.spotify.com/track/7pTZYIP7788EGovwcLf5WS",
      soundcloud: "https://soundcloud.com/lunartideband/take-me",
      amazonmusic: "https://music.amazon.com/albums/B089787236?trackAsin=B0896XPHZZ",
      tidal: "https://listen.tidal.com/track/142923899",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kJYGTAIQoVI_uL1N-zP7Igiv_1Qi9vyJI",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kJYGTAIQoVI_uL1N-zP7Igiv_1Qi9vyJI",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/mambali-legendofthedevildance.jpeg",
    artist: "Mambali",
    title: "Legend of The Devil Dance",
    role: "Engineering",
    releaseDate: "2020-02-28",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1495611988",
      spotify: "https://open.spotify.com/track/3lbCTaaHLLT0hm4WKsVOjX",
      soundcloud: "https://soundcloud.com/mambali-music/legend-of-the-devil-dance",
      amazonmusic: "https://music.amazon.com/albums/B0841ZTMTW?trackAsin=B0841ZW7QX",
      tidal: "https://listen.tidal.com/track/128688250",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/lunartide-leaveinlove.jpg",
    artist: "Lunar Tide",
    title: "Leave In Love",
    role: "Recording & Mixing",
    releaseDate: "2019-11-22",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1483741014",
      spotify: "https://open.spotify.com/track/0iCKGxKL9MaDc5NENxpqic",
      soundcloud: "https://soundcloud.com/lunartideband/lunar-tide-leave-in-love",
      amazonmusic: "https://music.amazon.com/albums/B07Z6CX6WJ?trackAsin=B07Z6D6T4J",
      tidal: "https://listen.tidal.com/track/120335050",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kcTaArTA81IuH5qNZczCvpPbhO8BkYCOo",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kcTaArTA81IuH5qNZczCvpPbhO8BkYCOo",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/mambali-yuwaniftemilywurramara.jpg",
    artist: "Mambali",
    title: "Yuwani (ft. Emily Wurramara)",
    role: "Engineering",
    releaseDate: "2019-05-31",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1460225784",
      spotify: "https://open.spotify.com/track/6fEwL0hrdIRLFR4yChTOmW",
      youtube: "https://www.youtube.com/watch?v=ZAFlHHg_n1E",
      youtubemusic: "https://music.youtube.com/watch?v=ZAFlHHg_n1E",
      soundcloud: "https://soundcloud.com/bevan-bara/yuwani-mambali-ft-emily",
      amazonmusic: "https://music.amazon.com/albums/B07QTY37L1?trackAsin=B07QTKDLQ6",
      tidal: "https://listen.tidal.com/track/107972723",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/caitbaker-yepyep.jpg",
    artist: "Caiti Baker",
    title: "Yep Yep",
    role: "Engineering",
    releaseDate: "2018-09-14",
    featured: false,
    show: true,
    links: {
      soundcloud: "https://soundcloud.com/caiti-baker/yep-yep-caiti-baker",
      bandcamp: "https://caitibaker.bandcamp.com/album/b6-ep",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/caitibaker-gimme.jpg",
    artist: "Caiti Baker",
    title: "Gimme",
    role: "Engineering",
    releaseDate: "2018-07-12",
    featured: true,
    show: true,
    links: {
      soundcloud: "https://soundcloud.com/caiti-baker/gimme",
      bandcamp: "https://caitibaker.bandcamp.com/album/b6-ep",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/publichigh-theytookmeaway.jpg",
    artist: "Public High",
    title: "They Took Me Away",
    role: "Recording, Mixing & Mastering",
    releaseDate: "2018-05-21",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1388375945",
      spotify: "https://open.spotify.com/track/3sEVx2fXlQrqE5CsJwLM4L",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/publichigh-whitelinefever.jpg",
    artist: "Public High",
    title: "White Line Fever",
    role: "Recording, Mixing & Mastering",
    releaseDate: "2018-02-09",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1347288612",
      spotify: "https://open.spotify.com/track/3pvJMtP5Nyito1rOfaRebK",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/publichigh-problemchild.jpg",
    artist: "Public High",
    title: "Problem Child",
    role: "Recording, Mixing & Mastering",
    releaseDate: "2017-10-20",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1308762662",
      spotify: "https://open.spotify.com/track/2S9ngOUGfmJVp637w9BU7P",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/caitibaker-zinc.jpg",
    artist: "Caiti Baker",
    title: "Zinc",
    role: "Engineering",
    releaseDate: "2017-06-10",
    featured: false,
    show: true,
    links: {
      bandcamp: "https://caitibaker.bandcamp.com/album/zinc",
      spotify: "https://open.spotify.com/album/6oYqJIq906Ds7Du34Ehe7U?si=e_7GMiomRQOBJLBVARl3yQ",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/paulkelly-lifeisfine.jpg",
    artist: "Paul Kelly",
    title: "Life Is Fine",
    role: "Assistant Engineering",
    releaseDate: "2017-08-11",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1440889150",
      spotify: "https://open.spotify.com/album/09yPletFnyFw0tlC8ls05x",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_n3uw83WzxUJLYdaKIopTIKqVI-ZhEvG6s",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_n3uw83WzxUJLYdaKIopTIKqVI-ZhEvG6s",
      soundcloud: "https://soundcloud.com/paul-kelly-official/sets/life-is-fine-2",
      amazonmusic: "https://music.amazon.com/albums/B075GFXCQR",
      tidal: "https://listen.tidal.com/album/77056245",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/publichigh-senttochurch.jpg",
    artist: "Public High",
    title: "Sent To Church",
    role: "Recording, Mixing & Mastering",
    releaseDate: "2017-06-12",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1248116834",
      spotify: "https://open.spotify.com/track/3KFW8vcBxoRTUISrX4SBvj",
      youtube: "https://www.youtube.com/watch?v=J1yG0G4zZpc",
      youtubemusic: "https://music.youtube.com/watch?v=J1yG0G4zZpc",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/longtermromance-babybyebye.jpg",
    artist: "Longterm Romance",
    title: "Baby Bye Bye",
    role: "Engineering & Mixing",
    releaseDate: "2017-04-27",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1230861679",
      spotify: "https://open.spotify.com/album/7FD2LL2w3dMUWDIViogTyy",
      soundcloud: "https://soundcloud.com/longtermromance/sets/baby-bye-bye-ep",
      amazonmusic: "https://music.amazon.com/albums/B073JR216P",
      tidal: "https://listen.tidal.com/album/73396019",
      bandcamp: "https://longtermromance.bandcamp.com/album/baby-bye-bye-3",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_lBjsR2_KpwV4jJ7eWwBt7qB3Ge7-oCSag",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_lBjsR2_KpwV4jJ7eWwBt7qB3Ge7-oCSag"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/alanawilkinson-iwannapunchonwithyou.png",
    artist: "Alana Wilkinson",
    title: "I Wanna Punch On With You",
    role: "Producing, Recording & Mixing",
    releaseDate: "",
    featured: false,
    show: false,
    links: {}
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/brokenriver-idontwanttoknow.jpg",
    artist: "Broken River",
    title: "I Don’t Want To Know",
    role: "Engineering",
    releaseDate: "2019-10-23",
    featured: false,
    show: true,
    links: {
      soundcloud: "https://soundcloud.com/brokenriver/i-dont-want-to-know",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/brokenriver-sometimes.jpg",
    artist: "Broken River",
    title: "Sometimes",
    role: "Engineering",
    releaseDate: "2019-10-23",
    featured: false,
    show: true,
    links: {
      soundcloud: "https://soundcloud.com/brokenriver/sometimes",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/brokenriver-meversusyou.jpeg",
    artist: "Broken River",
    title: "Me Versus You",
    role: "Engineering",
    releaseDate: "2016-05-12",
    featured: false,
    show: true,
    links: {
      soundcloud: "https://soundcloud.com/brokenriver/me-verses-you",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/blacksorrows-faithfulsatellite.jpg",
    artist: "The Black Sorrows",
    title: "Faithful Satellite",
    role: "Engineering",
    releaseDate: "2016-09-16",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1453807226",
      spotify: "https://open.spotify.com/album/6KUpbKHJRBZmHez2tsonPk",
      amazonmusic: "https://music.amazon.com/albums/B07P62HXPM",
      tidal: "https://listen.tidal.com/album/217917993",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_nWqgSjk8YnvTYe9H4VT8Kn_xhVIQXpWAo",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_nWqgSjk8YnvTYe9H4VT8Kn_xhVIQXpWAo",
      bandcamp: "https://theblacksorrows.bandcamp.com/album/faithful-satellite",
      soundcloud: "https://soundcloud.com/the-black-sorrows/sets/faithful-satellite-2"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/deborahconway-everybodysbegging.jpg",
    artist: "Deborah Conway & Willy Zygier",
    title: "Everybody’s Begging",
    role: "Assistant Engineering",
    releaseDate: "",
    featured: false,
    show: false,
    links: {}
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/paulkelly-sevensonnets.jpg",
    artist: "Paul Kelly",
    title: "Seven Sonnets & A Song",
    role: "Assistant Engineering",
    releaseDate: "2016-04-22",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1442941342",
      spotify: "https://open.spotify.com/album/1IoTlDmr8i21CMMIXWQGGj",
      soundcloud: "https://soundcloud.com/paul-kelly-official/sets/seven-sonnets-and-a-song",
      amazonmusic: "https://music.amazon.com/albums/B078HFV8CM",
      tidal: "https://listen.tidal.com/album/59464949",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_lMns8gXmoaYOVcE2yd1pbAlQQeo0KFlI0",
      youtube: "https://music.youtube.com/playlist?list=OLAK5uy_lMns8gXmoaYOVcE2yd1pbAlQQeo0KFlI0"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/skyscraperstan-liveatsvm.jpg",
    artist: "Skyscraper Stan",
    title: "Live at Some Velvet Morning",
    role: "Engineering",
    releaseDate: "2016-05-15",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1114376751",
      spotify: "https://open.spotify.com/album/1xs7VhKI0JsjV3n9A8wcrb",
      amazonmusic: "https://music.amazon.com/albums/B01FPI75QS",
      tidal: "https://listen.tidal.com/album/60543415",
      bandcamp: "https://skyscraperstan.bandcamp.com/album/live-at-some-velvet-morning",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kQMbB8sZavWji82PmgPuMwSrFyyRWZx3E",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kQMbB8sZavWji82PmgPuMwSrFyyRWZx3E"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/bashevissingers-bashevissingers.jpg",
    artist: "The Bashevis Singers",
    title: "The Bashevis Singers",
    role: "Engineering",
    releaseDate: "2016-03-21",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1098523124",
      spotify: "https://open.spotify.com/album/2G3xrvYUZxEFtF7mZUsGIP",
      amazonmusic: "https://music.amazon.com/albums/B01E0AOY1Q",
      soundcloud: "https://soundcloud.com/the-bashevis-singers/sets/the-bashevis-singers",

    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/gurrumul-gospelalbum.jpg",
    artist: "Geoffrey Gurrumul Yunupingu",
    title: "’Amazing Grace’ ft. Paul Kelly",
    role: "Assistant Engineering",
    releaseDate: "2015-07-31",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1537933381",
      spotify: "https://open.spotify.com/album/5ctBfMMOShJ5utdJXo8g7T",
      amazonmusic: "https://music.amazon.com/albums/B08M9V5W12",
      tidal: "https://listen.tidal.com/album/160531818",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kG5JOYSfH5FOOLAiy_zTRTLxTD6dPyKwQ",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kG5JOYSfH5FOOLAiy_zTRTLxTD6dPyKwQ",
      soundcloud: "https://soundcloud.com/gurrumul-official/amazing-grace-feat-paul-kelly"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/jamesreyne&magnificentfew.jpg",
    artist: "James Reyne & The Magnificent Few",
    title: "James Reyne & The Magnificent Few",
    role: "Engineering",
    releaseDate: "2015-07-03",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1004685629",
      amazonmusic: "https://music.amazon.com/albums/B09HRMLCP1",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_nDbg-pUJ1Wv0KlMHcjf3J3yoC4r-P6SfA",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_nDbg-pUJ1Wv0KlMHcjf3J3yoC4r-P6SfA",
      spotify: "https://open.spotify.com/album/4r7zJc0MKr6dETMBfHrYpB?si=9oV5O-nSSFaax1BTkllvhg",
      soundcloud: "https://soundcloud.com/james-reyne-official/sets/the-magnificent-few"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/dallasfrasca-lovearmy.jpg",
    artist: "Dallas Frasca",
    title: "Love Army",
    role: "Engineering",
    releaseDate: "2015-04-17",
    featured: true,
    show: true,
    links: {
      bandcamp: "https://dallasfrasca.bandcamp.com/album/love-army",
      spotify: "https://open.spotify.com/album/65YoeT7Qk8GLRqa8BsLLbC?si=0ZWgEJZ2SYS2_22a8AyqEQ",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_lvwFl5NYdik6ZNf4UoTgYJoymnTznbuIQ",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_lvwFl5NYdik6ZNf4UoTgYJoymnTznbuIQ",
      tidal: "https://tidal.com/browse/album/392393976",
      applemusic: "https://music.apple.com/au/album/love-army/1773014352",
      amazonmusic: "https://music.amazon.com/albums/B0DJS3NFQ5",
      soundcloud: "https://soundcloud.com/dallasfrasca/sets/love-army-masters-dallas"
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/psycroptic-psycroptic.jpg",
    artist: "Psycroptic",
    title: "Psycroptic",
    role: "Assistant Engineering",
    releaseDate: "2015-03-15",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1699374435",
      spotify: "https://open.spotify.com/album/3nDA8ksjVnst6cAhuc294z",
      soundcloud: "https://soundcloud.com/psycroptic-official/sets/psycroptic",
      amazonmusic: "https://music.amazon.com/albums/B00RBOCXQC",
      tidal: "https://listen.tidal.com/album/307279323",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kHUbQjqPhr8DeCo_1tASHX1DKnXa-Eics",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kHUbQjqPhr8DeCo_1tASHX1DKnXa-Eics",
      bandcamp: "https://psycroptic.bandcamp.com/album/psycroptic-2",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/skyscraperstan-lastyearstune.jpg",
    artist: "Skyscraper Stan & The Commission Flats",
    title: "Last Year’s Tune",
    role: "Engineering",
    releaseDate: "2015-03-06",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/968984200",
      bandcamp: "https://skyscraperstan.bandcamp.com/album/last-years-tune",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kEBELx3q9zx8my0mx1nNLPv4IciEET3ag",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kEBELx3q9zx8my0mx1nNLPv4IciEET3ag",
      tidal: "https://tidal.com/browse/album/95700814",
      amazonmusic: "https://music.amazon.com/albums/B07HMZRYWX",
      spotify: "https://open.spotify.com/album/6CTeccNYXLPSH9ih0nfyNd?si=m5WPJe59REG_I_Yabo35cQ",
      soundcloud: "https://soundcloud.com/skyscraperstan/sets/last-years-tune-1",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/somethingforkate-miraclecure.jpg",
    artist: "Something For Kate",
    title: "’Pleasure & Pain’",
    role: "Engineering",
    releaseDate: "2012-01-01",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/716223986",
      spotify: "https://open.spotify.com/track/5BHWxzu3aYCUKuQdwO6JCo",
      soundcloud: "https://soundcloud.com/something-for-kate/pleasure-and-pain",
      amazonmusic: "https://music.amazon.com/albums/B08VJ1VX5N?trackAsin=B08VJ1FN99",
      tidal: "https://listen.tidal.com/track/36515259",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_nkqtxfdxUYRLngiYqLrYe6292xxnRuAfY",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_nkqtxfdxUYRLngiYqLrYe6292xxnRuAfY",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/myleftboot-summersongs.jpg",
    artist: "My Left Boot",
    title: "Summer Songs",
    role: "Engineering",
    releaseDate: "2012-11-25",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/579833320",
      spotify: "https://open.spotify.com/album/5IsWCJbDBFvT1t97qLkLvQ",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_k64AEfI_125T0IIldAcv360--TAVsvbqM",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_k64AEfI_125T0IIldAcv360--TAVsvbqM",
      soundcloud: "https://soundcloud.com/myleftboot/sets/summer-songs",
      amazonmusic: "https://music.amazon.com/albums/B00AC7M50O",
      bandcamp: "https://myleftboot.bandcamp.com/album/summer-songs",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/juliastone-spotifysessions.jpg",
    artist: "Julia Stone",
    title: "Spotify Sessions",
    role: "Assistant Engineering",
    releaseDate: "2012-11-06",
    featured: true,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1595650536",
      spotify: "https://open.spotify.com/album/65y46VVei2js622FY15iiC",
      amazonmusic: "https://music.amazon.com/albums/B09LZ1C1ZC",
      tidal: "https://listen.tidal.com/album/205329942",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_kYhpNZEt4KSP-Iu0naNkLAu7p4l4OD5fo",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_kYhpNZEt4KSP-Iu0naNkLAu7p4l4OD5fo",
    }
  },
  {
    artwork: process.env.PUBLIC_URL + "assets/superjuice-freshlysqueezed.jpg",
    artist: "Superjuice",
    title: "Freshly Squeezed",
    role: "Producing, Recording & Mixing",
    releaseDate: "2012-03-08",
    featured: false,
    show: true,
    links: {
      applemusic: "https://geo.music.apple.com/au/album/_/1336786513",
      spotify: "https://open.spotify.com/album/4Pd3cMQqxVWSKIX9DcXNwv",
      amazonmusic: "https://music.amazon.com/albums/B0793HP2VT",
      tidal: "https://listen.tidal.com/album/83543518",
      bandcamp: "https://superjuice.bandcamp.com/album/freshly-squeezed",
      youtubemusic: "https://music.youtube.com/playlist?list=OLAK5uy_npQ0ZDacHhe29Dz1JGlfbH5kBx62tg9oM",
      youtube: "https://www.youtube.com/playlist?list=OLAK5uy_npQ0ZDacHhe29Dz1JGlfbH5kBx62tg9oM",
    }
  },
];

export default work;